// extracted by mini-css-extract-plugin
export default {"bookingSummary":"bookingSummary__XU6TC","bookingImg":"bookingImg__32NSl","bookingTitle":"bookingTitle__KHJRK","textContent":"textContent__16JAz"};
    if(module.hot) {
      // 1745482177196
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  